// Puertas de autenticación. AuthGate protege toda la app: muestra un cargador
// mientras hidrata la sesión, la pantalla de acceso si no hay usuario, o la app.
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { SignIn } from './SignIn';

export function SignedIn({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  return user ? <>{children}</> : null;
}

export function SignedOut({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  return user ? null : <>{children}</>;
}

export function AuthGate({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="auth-wrap">
        <div style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: 26, color: 'var(--primary)' }} />
          <p style={{ marginTop: 12 }}>Cargando…</p>
        </div>
      </div>
    );
  }

  return user ? <>{children}</> : <SignIn />;
}
